export default "__VITE_ASSET__94a66a97__"